/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'facebook': {
    width: 35,
    height: 35,
    viewBox: '0 0 35 35',
    data: '<g _fill="none" fill-rule="evenodd"><rect pid="0" _fill="#3B5B98" width="35" height="35" rx="17.5"/><path pid="1" d="M19 15h3l-.375 3H19v9h-3.89v-9H13v-3h2.11v-2.016c0-1.312.327-2.304.984-2.976C16.75 9.336 17.844 9 19.375 9H22v3h-1.594c-.594 0-.976.094-1.148.281-.172.188-.258.5-.258.938V15z" _fill="#FFF"/></g>'
  }
})



// WEBPACK FOOTER //
// ./src/components/icons/facebook.js